<div *ngIf="type === 'copyable'" class="overflow-hidden body-b2 pt-2 pl-2 rounded-xl chip truncate" (click)="copyText()">
  <span class="link" [matTooltip]="'chip.tooltip' | translate" [matTooltipPosition]="'below'">{{data}}</span>
</div>
<div *ngIf="type === 'regular' || type === 'warn'" class="body-b2 p-2 chip inline-flex items-center cursor-default rounded-xl pointer-events-none" [ngClass]="{'chip--warn' : type === 'warn'}">
  <mat-icon *ngIf="icon" svgIcon="{{icon}}" [ngClass]="{'chip__text--warn': type === 'warn'}" class="mx-2 chip__text"></mat-icon>
  <span [ngClass]="{'chip__text--warn': type === 'warn'}" class="link">{{data}}</span>
</div>
